import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const my_cohortsScreenModule = defineScreen({
  app: "coaching",
  screen_id: "my-cohorts",
  path: "/my-cohorts",
  heading: { text: "My cohorts", level: 1 },
  roles: {
    "super_admin": "deny",
    "admin": "deny",
    "coach": "allow",
    "company_admin": "deny",
    "participant": "allow",
    "cohort_lead": "deny"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "page.load" }
  ],
  recipe: "Page-1",
  data: { seedNeeds: ["readonly-walk-session"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/my-cohorts.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default my_cohortsScreenModule;
